import React from "react";
import styled from 'styled-components';

// Styled component for the image
const ImageSection = styled.div`
  flex: 0 0 auto; // Prevents the image from shrinking
  # padding: 20px; // Padding around the image
  padding-left: 100px;
  display: flex;
  align-items: center; // Centers the image vertically
`;

const TextSection = styled.div`
  flex: 1; // Takes up the remaining space
  padding:  80px; // Padding to space out the text from the image
  padding-right: 100px;
  color: #bdd2c5;
  display: flex;
  flex-direction: column; // Ensures that paragraphs are stacked vertically
  justify-content: center; // Centers the text vertically
  line-height: 2;
`;

const StyledAbout = styled.main`
  background-color: #041202; 
  display: flex; 
  min-height: 100vh;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 100px; /* Adjust the position */
    left: 520px; /* Adjust the position */
    width: 1300px; /* Adjust the size */
    height: 600px; /* Adjust the size */
    background: url('/blob2.svg') no-repeat center center;
    background-size: cover;
    filter: blur(15px); /* Adds blur to the edges */
    opacity: 0.2; /* Slightly transparent */
    z-index: 1;
  }
`;
 
function About() {
  return (
    <StyledAbout>
      <ImageSection>
        <img src="/yuluNew.jpg" alt="Yulu's portrait" style={{ width: '370px'}} />
      </ImageSection>
      <TextSection>
        <h2>About</h2>
        <p>
          Hi! My name is Yulu <i>/you-loo</i>; I'm a final-year Computer Engineering 
          student at the University of Toronto with experience across software, AI, 
          and autonomous systems. I'm naturally curious and love understanding not 
          just how things work, but the problems they're ultimately trying to solve.
        </p>
        <p>
          My experiences have taken me from leading the mapping team for U of T 
          Formula Racing's autonomous vehicle, to machine learning research, to 
          building software and AI products at Blue J. Through these experiences, 
          I've learnt that I enjoy tackling technical problems while thinking about the 
          users and broader goals behind what I'm building.
        </p>
        <p>
          I'm especially interested in work at the intersection of tech, 
          product, and people. whether that's designing a solution, evaluating tradeoffs, 
          or collaborating across teams to problem solve.
        </p>
        <p>
          Outside of work, I'm an enormous bookworm and love meeting new people, 
          exploring new ideas, and figuring out the "why" behind things. I'm always 
          looking for something new to learn, so feel free to reach out! I'd love 
          to chat!
        </p>
      </TextSection>
    </StyledAbout>
  );
}

export default About;
